import { css } from "@emotion/react";
import { vars } from "@imwebme/clay-token";

export const radioLabelCSS = css({
  display: "inline-flex",
  alignItems: "center",
  gap: vars.spacing[2],

  padding: `${vars.spacing["05"]} 0`,

  cursor: "pointer",

  "&:has(input:disabled)": {
    cursor: "not-allowed",
  },

  "&:has(input:disabled) [data-radio-label]": {
    color: vars.semantic.color.textDisabled,
  },
});

export const radioIconCSS = css({
  outlineWidth: "1px",
  outlineStyle: "solid",
  outlineColor: vars.semantic.color.borderMinimal,

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  position: "relative",

  backgroundColor: vars.semantic.color.actionSecondary,

  transition: "all ease-out 100ms",
  cursor: "pointer",

  "input:checked + &": {
    outlineColor: vars.semantic.color.actionPrimary,
  },

  "input:checked:disabled + &": {
    outlineColor: vars.semantic.color.actionPrimary,
    opacity: 0.3,
    cursor: "not-allowed",
  },

  "input:not(:checked):disabled + &": {
    outlineWidth: 0,
    backgroundColor: vars.semantic.color.actionSecondaryDisabled,
    cursor: "not-allowed",
  },

  "&:after": {
    "input:checked + &": {
      content: "''",
      position: "absolute",
      width: "8px",
      height: "8px",
      backgroundColor: vars.semantic.color.actionPrimary,
      borderRadius: vars.rounded.full,
    },
  },

  "&:not(input:disabled + &):hover": {
    backgroundColor: vars.semantic.color.actionSecondaryHover,

    "&:after": {
      backgroundColor: vars.semantic.color.actionPrimaryHover,
    },
  },

  "&:not(input:disabled + &):not(input:checked + &):hover": {
    backgroundColor: vars.semantic.color.actionSecondaryHover,
  },

  "&:where(input:disabled:not(:checked) + &)": {
    backgroundColor: vars.semantic.color.actionPrimaryDisabled,
  },
});
